<template>
  <div>
    <!-- Ratings: start -->
    <div
      v-if="ratingsView == 'percentage'"
      @click="toggleView"
      class="flex items-center justify-center gap-2 cursor-pointer"
    >
      <div class="w-1/2 text-right flex justify-end">
        <p
          class="text-sm w-fit rounded-full flex px-2 whitespace-nowrap"
          :class="
            maxPlusPercentage == plusPercentage
              ? 'bg-markencode-green text-white'
              : 'bg-transparent'
          "
        >
          {{ plusPercentage }}
        </p>
      </div>

      <div class="w-1/2 text-right flex justify-end">
        <p
          class="w-fit text-sm rounded-full flex px-2 whitespace-nowrap text-right"
          :class="
            maxMinusPercentage == minusPercentage
              ? 'bg-markencode-red text-white'
              : 'bg-transparent'
          "
        >
          {{ minusPercentage }}
        </p>
      </div>
    </div>

    <div
      v-if="ratingsView == 'absolute'"
      @click="toggleView"
      class="flex items-center justify-center gap-2 curspor-pointer"
    >
      <div class="w-1/2 text-right flex justify-end">
        <p
          class="text-sm w-fit rounded-full flex px-2 whitespace-nowrap text-right"
          :class="
            maxPlus == plus
              ? 'bg-markencode-green text-white'
              : 'bg-transparent'
          "
        >
          {{ plus }}
        </p>
      </div>

      <div class="w-1/2 text-right flex justify-end">
        <p
          class="w-fit text-sm rounded-full flex px-2 whitespace-nowrap text-right"
          :class="
            maxMinus == minus
              ? 'bg-markencode-red text-white'
              : 'bg-transparent'
          "
        >
          {{ minus }}
        </p>
      </div>
    </div>
    <!-- Ratings: end -->
  </div>
</template>

<script>
export default {
  name: 'ProfileRatings',

  props: ['session', 'option', 'ratingStats', 'ratingsView'],

  data() {
    return {
      ratings: {
        plus: this.ratingStats.stats[this.option.id].plus || 0,
        minus: this.ratingStats.stats[this.option.id].minus || 0,
      },
      totalPlus: this.ratingStats.totalPlus || 0,
      totalMinus: this.ratingStats.totalMinus || 0,
      maxPlus: this.ratingStats.maxPlus || null,
      maxMinus: this.ratingStats.maxMinus || null,
    };
  },

  mounted() {
    Echo.channel('markencode-app.session.' + this.session.id).listen(
      '.profile-ratings.submitted',
      (e) => {

        console.log('profile-ratings.submitted');

        this.ratings = e.ratings.stats[this.option.id] || {
          plus: 0,
          minus: 0,
        };
        this.totalPlus = e.ratings.totalPlus || 0;
        this.totalMinus = e.ratings.totalMinus || 0;
        this.maxPlus = e.ratings.maxPlus || null;
        this.maxMinus = e.ratings.maxMinus || null;

        this.$emit('ratings_total')
      }
    );
  },

  methods: {
    toggleView() {
      this.$emit(
        'ratingsViewToggled',
        this.ratingsView == 'percentage' ? 'absolute' : 'percentage'
      );
    },
  },

  computed: {
    plusPercentage() {
      if (this.totalPlus <= 0 || !this.ratings.plus) {
        return 0;
      }

      return ((this.ratings.plus / this.totalPlus) * 100).toFixed(0);
    },

    minusPercentage() {
      if (this.totalMinus <= 0 || !this.ratings.minus) {
        return 0;
      }

      return ((this.ratings.minus / this.totalMinus) * 100).toFixed(0);
    },

    maxPlusPercentage() {
      if (this.totalPlus <= 0 || !this.maxPlus) {
        return null;
      }

      return ((this.maxPlus / this.totalPlus) * 100).toFixed(0);
    },

    maxMinusPercentage() {
      if (this.totalMinus <= 0 || !this.maxMinus) {
        return null;
      }

      return ((this.maxMinus / this.totalMinus) * 100).toFixed(0);
    },

    plus() {
      return this.ratings.plus || 0;
    },

    minus() {
      return this.ratings.minus || 0;
    },
  },
};
</script>